import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useMachineInfo } from '../../../abelcommon/hooks/useMachineInfo';
import { env } from '../../../api';
import { MachineListSection } from './components/MachineListSection';
import { StatisticSection } from './components/StatisticSection';
import { useTranslation } from 'react-i18next';

export const MachinePage = () => {
  const {
    refetchingGetMiner,
    refetchingGetStatMiner,
    minerListData,
    statMinerList,
    summaryMachineInfo,
    refetchGetStatMiner,
    refetchGetMinerList,
  } = useMachineInfo();
  const { t } = useTranslation();

  const handleRefetchStatMiner = () => {
    refetchGetStatMiner && refetchGetStatMiner();
    refetchGetMinerList && refetchGetMinerList();
  };

  useEffect(() => {
    document.title = env.title + ` | ${t('machineListSectionPage.machine')}`;
  }, [t]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <StatisticSection
          statMinerData={statMinerList}
          onRefetchStatMiner={handleRefetchStatMiner}
          isFetching={refetchingGetMiner || refetchingGetStatMiner}
        />
      </Grid>
      <Grid item xs={12}>
        <MachineListSection
          minerData={minerListData}
          summaryMachineInfo={summaryMachineInfo}
          onRefetchStatMiner={handleRefetchStatMiner}
        />
      </Grid>
    </Grid>
  );
};
